var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"menu"},[_c('Menu')],1),_c('div',{staticClass:"content"},[_c('router-view',{key:_vm.fullPath})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }